import {neverland as $, render, html, useState, useEffect} from 'neverland';

import Select from './Select.js';

function isInteger(value) {
	return /^\d+$/.test(value);
}

function fixType(value) {
	if (value == "true") {
		return true;
	} else if (value == "false") {
		return false;
	} else if (isInteger(value)) {
		return Number(value);
	} else {
		return value;
	}
}

const SelectSubField = function(f, fields, idx, sf, doc, updateDocByFunction, collection, sequenceUpdateId, continuityId) {

	let subfields = fields[f].fields;

	let options = [];

	function getOptionsFromPrevious(sf, f){
		let prevItemsInSet = [],
			maxRecursiveCalls = 20,
			nRecursiveCalls = 0;

		function getItems(seq) {

			nRecursiveCalls++;

			if (nRecursiveCalls >= maxRecursiveCalls) {
				console.log('Maximum recursive calls reached.')
			}

			for (let el of seq) {

				// Handle differently if Item or ItemSet.
				if (el.collection == "Items") {
					
					// Push Item details to items.
					let matchingItems = (collection.fullCollections && collection.fullCollections['Items']) ? collection.fullCollections['Items'].filter(d => d.id == el.element) : [];
					if (matchingItems.length > 0) {
						prevItemsInSet.push(matchingItems[0]);
					}

				} else if (el.collection == "ItemSets") {

					// Extract elements in ItemSet and recursively call getItems on it.
					let matchingItemSets = (collection.fullCollections && collection.fullCollections['ItemSets']) ? collection.fullCollections['ItemSets'].filter(d => d.id == el.element) : [];
					if (matchingItemSets.length > 0 && nRecursiveCalls < maxRecursiveCalls) {
						
						getItems(matchingItemSets[0].elements);
						
					}
				}

			}

		}

		["endscreenConditions"].includes(f) ? getItems(doc.curr.elements) : getItems(doc.curr.elements.slice(0, f_idx));

		// For now, only allow choose-1, dropdown-1 or text types.
		let allowedTypes = ['choose-1', 'dropdown-1', 'text', 'calculator']
		if (f === "endscreenConditions"){
			allowedTypes = ['calculator', 'choose-1']
		} 
		
		prevItemsInSet = prevItemsInSet.filter(d => allowedTypes.includes(d.type));

		let optIDs = prevItemsInSet.map(d => d.value);
		options = subfields[sf].options.filter(d => optIDs.includes(d.value));

		return options;
	}

	if (sf == "item" && f == "endscreenConditions"){
		options = getOptionsFromPrevious(sf, f);
	} else if (sf == "value" && f == "endscreenConditions"){
		let prevItems = getOptionsFromPrevious("item", f);
		let matchingItems = prevItems.filter(d => d.id == doc.curr[f][idx].item);

		if(matchingItems.length > 0){
			options = matchingItems[0].options
		}
	}else{
		options = subfields[sf].options;
	}

	function updateSubField(newVal) {
		
		if (subfields[sf].multiple) {
			newVal = newVal.map(v => fixType(v));
		} else {
			newVal = fixType(newVal);
		}

		updateDocByFunction(prevDoc => {
			let doc = {...prevDoc},
				seq = [...doc.curr[f]];
			seq[idx][sf] = newVal;
			if (subfields[sf].isReference) {
				if (newVal == '') {
					seq[idx].collection = null;
				} else {
					seq[idx].collection = options.filter(d => d.value == newVal)[0].collection;
				}
			}
			doc.curr[f] = seq;
			return doc;	
		})
	}

	return html`
		<label>${subfields[sf].title}</label>
		${Select(
			options,
			doc.curr[f][idx][sf],
			updateSubField,
			subfields[sf].groupByCollection,
			subfields[sf].optionCollections,
			subfields[sf].searchEnabled,
			subfields[sf].multiple,
			subfields[sf].hideOptions)}
	`;

	// 	${!subfields[sf].multiple ? html`<option value="">&nbsp;</option>` : ''}
};

export default SelectSubField;